/* Script for accessibility fixes */
$(window).load(function() {
	var alts = [{
			s: 'global_footer_asi_img_1.png',
			a: "Mens's Health Logo"
		},
		{
			s: 'global_footer_asi_img_2.png',
			a: "GQ logo"
		},
		{
			s: 'global_footer_asi_img_3.png',
			a: "AskMen logo - Registered trademark"
		},
		{
			s: 'global_footer_asi_img_4.png',
			a: "Complex Logo"
		},
		{
			s: 'global_footer_asi_img_5.png',
			a: "MAXIM Logo"
		},
		{
			s: 'ilf-package.png',
			a: "ILF Package"
		}
	];

	alts.forEach(function(item) {
		$('[src*="' + item.s + '"]').attr('alt', item.a);
	});


	var labels = [{
			s: '#mce-EMAIL',
			l: "Email"
		},
		{
			s: '#mc-embedded-subscribe',
			l: "subscribe"
		}, {
			s: '.byo--accessory-view button.slick-prev',
			l: "Previous"
		}, {
			s: '.byo--accessory-view button.slick-next',
			l: "Next"
		},
	];

	labels.forEach(function(item) {
		$(item.s).attr('aria-label', item.l);
	});


	$('.cart-sidecar-close > span').attr({
		"role": "button",
		"aria-label": "Close",
		"tabindex": "0"
	});
	$('.cart-sidecar-close > span').addClass('a11y-keyboard');

	$('body').on('keydown', ".a11y-keyboard", function(event) {
		if (event.keyCode == "13") {
			$(this).click();
		}
	});

	$(".cart-sidecar-header > strong").attr({
		"role": "heading",
		"aria-level": "2"
	});
	$('.reviews-slider .slick-track').removeAttr('role');
	$('.reviews-slider .slick-track > .slide').removeAttr('role');

	$('ul.scroll-links > li > a:not([data-action="reviews-toggle"])').click(function() {
		var link = $(this).attr('href');
		$(link).attr("tabindex", '-1');
		$(link).focus();
	});

	$('#whats-included h4').attr({
		"role": "heading",
		"aria-level": "2"
	});

	$('.pagination > span.page.current, .blog-pagination > span.page.current').attr("aria-current", "page");
	$('.pagination, .blog-pagination').attr("role", "list");
	$('.pagination > span, .blog-pagination > span').attr("role", "listitem");

	$('.pagination > span, .blog-pagination > span').each(function() {
		$(this).find('a').attr("aria-label", "Page " + $(this).text().trim())
	});


	if ($('#deals').hasClass('template__collection--no-sidebar')) {
		document.title += " - " + $("#shorting-method-a11y").text().trim();
	}

	$(".sidebar aside").attr({
		"role": "navigation",
		"aria-label": "Side"
	});

	$("#ccpaSuccessMsgContainer").attr("role", "alert");

	var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
	if (isMobile) {
		//Script for Mobile
		$('.footer-menu-module strong').attr({
			'role': 'button',
			'tabindex': "0",
			"aria-expanded": "false"
		});
		$('.footer-menu-module.open strong').attr("aria-expanded", true);
		$('.footer-menu-module strong').click(function() {
			var state = $(this).attr("aria-expanded");
			$('.footer-menu-module strong').attr("aria-expanded", false);
			$(this).attr("aria-expanded", state == "false");
		});
	} else {
		$(".footer-menu-module").addClass('open');
		//Script for Desktop
	}
	$(".mobile-language-item.current_lang").attr("aria-current", true);

	$('.nav-items.desktop > li > a:not([target="_blank"])').keydown(function(event) {
		var key = event.key;
		if (key == ' ') {

			var dropdown = $('.main-navigation .nav-dropdown> li:nth-child(' + ($(this).parent().index() + 1) + ')');
			dropdown.toggle();
			dropdown.parent().toggleClass('open');
			event.preventDefault();
		}
	});

	$('#skip-link').click(function() {
		$('#main-region').attr('tabindex', -1);
		$('#main-region').focus();
	});

	$('.owl-controls > .owl-nav > div.owl-prev').attr({
		'tabindex': "0",
		'role': "button",
		"aria-label": "Previous"
	});
	$('.owl-controls > .owl-nav > div.owl-next').attr({
		'tabindex': "0",
		'role': "button",
		"aria-label": "Next"
	});
	$('.owl-controls > .owl-nav > div').addClass('a11y-keyboard');


	$("#shorting-method-a11y").click(function() {
		$(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
	});

	$("#shorting-method-a11y+span+ul li.active").attr("aria-current", true);

	$('[data-action="modal-open"]').click(function() {
		var modalID = $(this).attr('data-modal');
		setTimeout(function() {
			$("#" + modalID).find('[data-action="modal-close"]').first().focus();
		}, 1000);
	});

	$("#a11y-product-rating-button").click(function() {
		$("#a11y-product-reviews span.h2").attr('tabindex', -1);
		setTimeout(function() {
			$("#a11y-product-reviews span.h2").focus();
		}, 1000);
	});

	$('.yotpo-popup-box-small[role="tablist"] .yotpo-nav-tab').attr({
		"tabindex": "-1"
	});
	$('.yotpo-popup-box-small[role="tablist"] .yotpo-nav-tab.yotpo-active').attr({
		"tabindex": "0"
	});

	// 	$('div.yotpo-pager a.yotpo_previous, div.yotpo-pager a.yotpo_next, .byo--selection-items > div.byo--build-block').attr({
	// 		'tabindex': "0",
	// 		role: "button"
	// 	});
	$('div.yotpo-pager a.yotpo_previous, div.yotpo-pager a.yotpo_next, .byo--selection-items > div.byo--build-block').addClass('a11y-keyboard');

	$('#a11y-cart-end').focus(function(event) {
		$('.cart-sidecar-header .cart-sidecar-close > span').focus();
		event.preventDefault();
	});

	$('#a11y-cart-toggler').click(function() {
		$('.cart-sidecar-close > span').focus();
		setTimeout(function() {
                  $('.cart-sidecar-close > span').focus();
			$('.cart-sidecar [data-cart-contents]').parents().siblings().filter(':not(#a11y-cart-end)').attr("aria-hidden", true);
		}, 500);
	});

	$('.cart-sidecar-close > span').click(function() {
		$('.cart-sidecar [data-cart-contents]').parents().siblings().removeAttr("aria-hidden");
		$('#a11y-cart-toggler').focus();
	});

	$('.cart-sidecar-items li').each(function() {
		var alt = $(this).find('.cart-sidecar-items-meta-title.line-item-title').text().trim();
		$(this).find('a.image').append('<span class="sr-only">' + alt + '</span>');
		$(this).find(".cart-sidecar-items-meta-remove.remove-item ").attr({
			"tabindex": "0",
			"role": "button"
		});
		$(this).find(".cart-sidecar-items-meta-remove.remove-item ").addClass("a11y-keyboard");

	});
	$(".a11y-expandable").click(function() {
		$(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
	});

	$("#review-end").focus(function(event) {
		event.preventDefault();
		$("#review-handle").focus();

	});

	$(":empty").filter("h1,h2,h3,h4,h5,h6").remove();

	//                   findInsiders($(".more-dropdown.js-more-dropdown"));
	//                   findInsiders($(".sorting-menu.js-sort-menu"));
	$(".last-tabable").on('focus', function(e) {
		e.preventDefault();
		$(this).parent().parent().find('.to-first-tabable').focus();
		// 		console.log($(this).parent().parent().find('.to-first-tabable'));
	});
	$(".byo--step-button-container a.disabled").attr("tabindex", "-1");

	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.attributeName === "class") {
				var attributeValue = $(mutation.target).prop(mutation.attributeName);
				$(mutation.target).removeAttr('tabindex');
			}
		});
	});

	document.querySelectorAll('.byo--step-button-container a').forEach(function(singleNode) {
		observer.observe(singleNode, {
			attributes: true
		});
	});

	$("#your-shopping-cart .a11y-hide-strong > strong").attr("aria-hidden", true);
	$("form table").attr('role', "none");

	$(".byo--selection-items").attr("role", "radiogroup");
	$(".byo--selection-items").each(function() {
		$(this).find(".byo--build-block").attr({
			"tabindex": "0",
			"role": "radio",
			"aria-checked": "false"
		});
		$(this).find(".byo--build-block").click(function() {
			$(this).parent().find(".byo--build-block").attr({
				"aria-checked": "false",
				"tabindex": "-1"
			});
			$(this).attr({
				"aria-checked": "true",
				"tabindex": "0"
			});
		});
		$(this).find(".byo--build-block").keyup(function(event) {
			var key = event.key;
			switch (key) {
				case "ArrowRight":
				case "ArrowDown":
					event.preventDefault();
					$(this).next().click();
					$(this).next().focus();
					break;

				case "ArrowUp":
				case "ArrowLeft":
					event.preventDefault();
					$(this).prev().click();
					$(this).prev().focus();
					break;
			}
		});
	});
	
	$(".byo--selection-items .byo--checkmark").attr("aria-hidden", "true");
	$('svg[id], svg [id]').removeAttr('id');

	console.log("A11y Patched...");
});